export const DEHYDRATE_KEY = 'Dehydrate/Ticket'

export default function() {
    const state = JSON.parse(localStorage.getItem(DEHYDRATE_KEY))

    if (state && state.ticket.reportPdfTicketsOption) {
        state.ticket.reportPdfTicketsOption.from = state.ticket.reportPdfTicketsOption.from && new Date(state.ticket.reportPdfTicketsOption.from),
        state.ticket.reportPdfTicketsOption.to = state.ticket.reportPdfTicketsOption.to && new Date(state.ticket.reportPdfTicketsOption.to)
    }

    if (state && state.ticket.exportTicketsOption) {
        // migration
        state.ticket.exportXlsxTicketsOption = state.ticket.exportTicketsOption
        delete state.ticket.exportTicketsOption
    }

    return state
}


// WEBPACK FOOTER //
// ./lib/ticket/hydrate.js